import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { minicrudsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useMinicrudsState = () => React.useContext(Context) || {}
export const useMinicruds = () => useMinicrudsState()?.minicruds || []

const QUERY = gql`
  query Minicruds($page: Int, $search: String, $sort: MinicrudSort, $filter: MinicrudFilter) {
    minicruds(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      deleted
    }
  }
`

const MinicrudsLoader = ({ children, uncontrolledChildren, filter }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filterState = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filterState, ...filter }
    },
    client: minicrudsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default MinicrudsLoader
